<template>
  <div class="ui shape">
    <div class="sides">
      <div class="active side">
        <generic-container
          v-bind:show_plus="true"
          icon="cogs"
          :title="$t('templates')"
          v-on:add="add"
        >
          <div class="ui two link cards">
            <div
              class="card"
              v-for="(template, index) in templates"
              :key="index"
              @click="edit(template)"
            >
              <div class="content">
                <div class="header">{{ template.name }}</div>
                <div class="description">
                  <pre>{{ template.template | truncate(100) }}</pre>
                </div>
              </div>
            </div>
          </div>
        </generic-container>
      </div>
      <div class="side">
        <code-editor
          v-model="code"
          :type="type"
          :icon="icon"
          theme="monokai"
          ref="html_code_editor"
          :title="title"
          :show_format="true"
          :header_buttons="header_buttons"
        >
          <div class="ui form" style="margin-bottom:15px">
            <div class="field">
              <label for="">{{ $t("name") }}</label>
              <input type="text" name="name" v-model="name" />
            </div>
          </div>
        </code-editor>
      </div>
    </div>
  </div>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import CodeEditor from "@/components/code_editor/Index";

export default {
  name: "TplManager",
  data() {
    return {
      code: "",
      name: "",
      header_buttons: [
        {
          icon: "left arrow",
          tooltip: "back",
          click: function() {
            window.jQuery(".shape").shape("flip over");
          },
        },
      ],
    };
  },
  components: { GenericContainer, CodeEditor },
  props: { templates: Array, type: String, title: String, icon: String },
  methods: {
    add() {
      console.log("add");
    },
    edit(template) {
      console.log(template);
      this.code = template.template;
      this.name = template.name;
      window.jQuery(".shape").shape("flip over");
    },
  },
};
</script>
